import { injectReducer } from 'store/reducers.js'
import { authRoute } from 'helpers/routes'

export const RoutesRoute = (store) => Object.assign({}, authRoute(store), {
  path: 'routes',
  authentication: 'admin',
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const Container = require('./containers/RoutesContainer').default

      const actions = require('./modules/routes').actions
      const reducer = require('./modules/routes').default

      injectReducer(store, { key: 'routes', reducer })

      store.dispatch(actions.get())

      cb(null, Container)
    }, 'routes')
  }
})

export const NewRouteRoute = (store) => Object.assign({}, authRoute(store), {
  path: 'routes/new',
  authentication: 'admin',
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const Container = require('./containers/NewRouteContainer').default

      const reducer = require('./modules/route').default

      injectReducer(store, { key: 'route', reducer })

      cb(null, Container)
    }, 'routes')
  }
})

export const EditRouteRoute = (store) => Object.assign({}, authRoute(store), {
  path: 'routes/:id/edit',
  authentication: 'admin',
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const Container = require('./containers/EditRouteContainer').default

      const actions = require('./modules/route').actions
      const reducer = require('./modules/route').default

      injectReducer(store, { key: 'route', reducer })

      store.dispatch(actions.get(nextState.params.id))

      cb(null, Container)
    }, 'routes')
  }
})

export default function (store) {
  return [
    NewRouteRoute(store),
    EditRouteRoute(store),
    RoutesRoute(store)
  ]
}



// WEBPACK FOOTER //
// ./src/routes/Routes/index.js